import React from "react";
import { queryDocumentReniec } from "../../../apis/apis.logistics/apisSunat";
import { toast } from "react-toastify";
import { personDocumentTypes } from "../../../configs/Data";
import { recalculateAllItems } from "../../../configs/helpers";

const inputClass =
    "w-full rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-white text-sm px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors";
const labelClass =
    "block text-xs font-semibold text-gray-600 dark:text-gray-400 uppercase tracking-wide mb-1";

export function NewOrderPurchaseOperationForm({
    order,
    setOrder,
    selectedOption,
    setSelectedOption,
}) {
    const getPersonData = async (
        typeDocument,
        numberDocument,
        isClient,
        isSupplier,
    ) => {
        try {
            const response = await queryDocumentReniec({
                documentType: typeDocument,
                documentNumber: numberDocument,
                isClient: isClient,
                isSupplier: isSupplier,
            });
            return response;
        } catch (error) {
            throw error;
        }
    };
    const handleChangeOperation = (e) => {
        const newOrder = { ...order, [e.target.name]: e.target.value };
        if (e.target.name === "conditionIgv") {
            const recalculatedOrder = recalculateAllItems(newOrder);
            setOrder(recalculatedOrder);
        } else {
            setOrder(newOrder);
        }
    };
    const handleChangeOperationSupplierDocumentType = (e) => {
        setOrder({
            ...order,
            supplierDocumentType: e.target.value,
            operationDocumentTypeID: e.target.value == "06" ? "03" : "01",
        });
    };
    const handleChangeOperationSupplier = (e) => {
        setOrder({
            ...order,
            [e.target.name]: e.target.value,
        });
    };
    const handleKeyDownSupplier = async (e) => {
        if (e.keyCode === 13) {
            let res = await getPersonData(
                order.supplierDocumentType,
                order.supplierDocumentNumber,
                false,
                true,
            );

            if (!res.error) {
                setOrder({
                    ...order,
                    supplierFirstSurname: res.firstSurname,
                    supplierName: res.name,
                    supplierSecondSurname: res.secondSurname,
                    supplierFiscalAddress: res.fiscalAddress,
                });
                toast.info(res.message);
            } else {
                setOrder({
                    ...order,
                    supplierFirstSurname: "",
                    supplierName: "",
                    supplierSecondSurname: "",
                    supplierFiscalAddress: "",
                });
                toast.error(res.message);
            }
        }
    };

    /*useEffect(() => {
    getWarehouses(auth.data.subsidiary.subsidiary_id);
  }, []);*/
    return (
        <>
            <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm overflow-hidden mb-4">
                <div className="p-5">
                    <h6 className="text-base font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                        <i className="fas fa-file-invoice-dollar text-blue-500"></i>
                        Datos de la Operación
                    </h6>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="md:col-span-1">
                            <label className={labelClass}>Fecha</label>
                            <input
                                type="date"
                                name="operationDate"
                                className={inputClass}
                                value={order.operationDate}
                                onChange={handleChangeOperation}
                            />
                        </div>
                        <div className="md:col-span-1">
                            <label className={labelClass}>
                                Número de Factura
                            </label>
                            <input
                                type="text"
                                maxLength={20}
                                className={inputClass}
                                name="operationDocumentNumber"
                                id="operationDocumentNumber"
                                placeholder="Ingrese Nro. Factura"
                                autoComplete="off"
                                value={order.operationDocumentNumber}
                                onChange={(e) => {
                                    setOrder({
                                        ...order,
                                        operationDocumentNumber: e.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className="md:col-span-1">
                            <label className={labelClass}>
                                Código de Pedido
                            </label>
                            <input
                                type="text"
                                maxLength={20}
                                className={inputClass}
                                name="code"
                                id="code"
                                placeholder="Ingrese Código de Pedido"
                                autoComplete="off"
                                value={order.code}
                                onChange={(e) => {
                                    setOrder({
                                        ...order,
                                        code: e.target.value,
                                    });
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>

            <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm overflow-hidden mb-4">
                <div className="p-5">
                    <h6 className="text-base font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                        <i className="fas fa-user-tie text-blue-500"></i>
                        Datos del Proveedor
                    </h6>

                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                        <div className="md:col-span-1">
                            <label className={labelClass}>
                                Tipo de Documento
                            </label>
                            <select
                                className={inputClass}
                                name="supplierDocumentType"
                                value={order.supplierDocumentType}
                                onChange={
                                    handleChangeOperationSupplierDocumentType
                                }
                            >
                                {personDocumentTypes.map((item, index) => {
                                    return (
                                        <option key={index} value={item.id}>
                                            {item.name}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>

                        <div className="md:col-span-1">
                            <label className={labelClass}>
                                Número de Documento
                            </label>
                            <input
                                type="text"
                                className={inputClass}
                                name="supplierDocumentNumber"
                                placeholder="Ingrese Nro. Documento"
                                value={order.supplierDocumentNumber}
                                onChange={handleChangeOperationSupplier}
                                onKeyDown={handleKeyDownSupplier}
                                maxLength={11}
                                autoComplete="off"
                            />
                        </div>

                        <div className="md:col-span-1">
                            <label className={labelClass}>
                                Nombres / Razón Social
                            </label>
                            <input
                                type="text"
                                className={inputClass}
                                name="supplierName"
                                placeholder="Ingrese Nombres o Razón Social"
                                value={order.supplierName}
                                onChange={handleChangeOperationSupplier}
                                maxLength={200}
                            />
                        </div>
                    </div>

                    {order.supplierDocumentType != "06" ? (
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
                            <div>
                                <label className={labelClass}>
                                    Apellido Paterno
                                </label>
                                <input
                                    type="text"
                                    className={inputClass}
                                    name="supplierFirstSurname"
                                    placeholder="Ingrese Apellido Paterno"
                                    value={order.supplierFirstSurname}
                                    onChange={handleChangeOperationSupplier}
                                    maxLength={200}
                                    autoComplete="off"
                                />
                            </div>
                            <div>
                                <label className={labelClass}>
                                    Apellido Materno
                                </label>
                                <input
                                    type="text"
                                    className={inputClass}
                                    name="supplierSecondSurname"
                                    placeholder="Ingrese Apellido Materno"
                                    value={order.supplierSecondSurname}
                                    onChange={handleChangeOperationSupplier}
                                    maxLength={200}
                                    autoComplete="off"
                                />
                            </div>
                        </div>
                    ) : (
                        <div className="mt-4">
                            <label className={labelClass}>Dirección</label>
                            <input
                                type="text"
                                className={inputClass}
                                name="supplierFiscalAddress"
                                placeholder="Ingrese Dirección"
                                value={order.supplierFiscalAddress}
                                onChange={handleChangeOperationSupplier}
                                maxLength={500}
                                autoComplete="off"
                            />
                        </div>
                    )}
                </div>
            </div>
            {/* Condición IGV & Aumentar Stock */}
            <div className="rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 shadow-sm overflow-hidden mb-4">
                <div className="p-5">
                    <h6 className="text-base font-semibold text-gray-900 dark:text-white mb-4 flex items-center gap-2">
                        <i className="fas fa-percentage text-blue-500"></i>
                        Condición IGV & Aumentar Stock
                    </h6>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className={labelClass}>Condición IGV</label>
                            <select
                                className={inputClass}
                                name="conditionIgv"
                                value={order.conditionIgv}
                                onChange={handleChangeOperation}
                            >
                                <option value="01">IGV Incluido</option>
                                <option value="02">IGV Aparte</option>
                            </select>
                        </div>
                        <div>
                            <label className={labelClass}>Aumentar Stock</label>
                            <select
                                className={inputClass}
                                name="affectsStock"
                                value={order.affectsStock}
                                onChange={(e) => {
                                    setOrder({
                                        ...order,
                                        affectsStock: e.target.value === "true",
                                    });
                                }}
                            >
                                <option value="true">Aumentar Stock</option>
                                <option value="false">No Aumentar Stock</option>
                            </select>
                        </div>
                    </div>
                    <div className="mt-4 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-lg border border-blue-200 dark:border-blue-800">
                        <div className="flex items-start gap-2">
                            <i className="fas fa-info-circle text-blue-500 text-lg mt-0.5"></i>
                            <span className="text-sm text-blue-800 dark:text-blue-300">
                                {order.conditionIgv === "01"
                                    ? "El precio ingresado ya incluye el IGV del 18%"
                                    : "El precio ingresado no incluye IGV, se calculará aparte"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
